import {
  HTTP_REQUEST_FAILED,
  HTTP_REQUEST_STARTED,
  HTTP_REQUEST_SUCCEEDED
} from '../app-communication/actions/http-requests';

export const initialState = {
  specified: [],
  unspecified: 0
};

const getRequestTypeName = (payload) => payload.requestedAction && payload.requestedAction.requestTypeName;

export const httpRequestsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case HTTP_REQUEST_STARTED:
      const httpRequestStartedTypeName = getRequestTypeName(payload);

      if (httpRequestStartedTypeName) {
        return {
          ...state,
          specified: state.specified
            .filter((request) => request !== httpRequestStartedTypeName)
            .concat(httpRequestStartedTypeName)
        };
      }

      return {
        ...state,
        unspecified: state.unspecified + 1
      };

    case HTTP_REQUEST_SUCCEEDED:
    case HTTP_REQUEST_FAILED:
      const httpRequestTypeName = getRequestTypeName(payload);

      if (httpRequestTypeName) {
        return {
          ...state,
          specified: state.specified.filter((request) => request !== httpRequestTypeName)
        };
      }

      return {
        ...state,
        unspecified: state.unspecified - 1
      };
    default:
      return state;
  }
};
